import { Navigate, Outlet } from "react-router-dom";
import { getGluceraAccessToken } from "../utils/storage";
import GluceraNavigationRoutes from "../utils/navigationRoutes";
import { jwtDecode } from "jwt-decode";

const GluceraProtectedRoute = () => {
  // Check if token exists and is valid
  const checkTokenValidity = () => {
    const token = getGluceraAccessToken();
    if (!token) {
      return false;
    }

    try {
      const decoded: any = jwtDecode(token);
      const currentTime = Date.now() / 1000;

      // If token is expired
      if (decoded.exp < currentTime) {
        // Clear ALL storage for expired token
        localStorage.removeItem("glucera_access_token");
        localStorage.removeItem("glucera_user_info");
        localStorage.removeItem("glucera_refresh_token");
        localStorage.removeItem("accessToken");
        localStorage.removeItem("userInfo");
        localStorage.removeItem("refreshToken");
        sessionStorage.clear();
        return false;
      }

      return true;
    } catch (_error) {
      // Clear ALL storage for invalid token
      localStorage.removeItem("glucera_access_token");
      localStorage.removeItem("glucera_user_info");
      localStorage.removeItem("glucera_refresh_token");
      localStorage.removeItem("accessToken");
      localStorage.removeItem("userInfo");
      localStorage.removeItem("refreshToken");
      sessionStorage.clear();
      return false;
    }
  };

  const isAuthenticated = checkTokenValidity();

  return isAuthenticated ? (
    <Outlet />
  ) : (
    <Navigate
      to={"/glucera" + GluceraNavigationRoutes.ONBOARDING_LOGINPAGE}
      replace
    />
  );
};

export default GluceraProtectedRoute;
